import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';

import Loader from "components/elements/loader/Loader";
import { showWarningMessage } from "reducers/application/applicationActions";

class ConfirmModal extends Component {

    constructor(props) {
        super(props);
    }

    accept = () => {
        console.log("here", this.props.disbursementId);
        this.props.annul(this.props.disbursementId);
    }

    render() {
        return (
            <Modal
                {...this.props}
                animation={false}
                bsSize="large"
                aria-labelledby="contained-modal-title-sm"
                backdrop={"static"} >
                <Modal.Header>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>{this.props.message}</div>
                </Modal.Body>

                <Modal.Footer>
                    {this.props.loading == false ?
                        <div>
                            <Button onClick={this.props.onHide} >Cerrar</Button> &nbsp;
                            <Button onClick={this.accept} className="bg-light-secondary">Aceptar</Button>
                        </div>
                        :
                        <div className="w-100">
                            <Loader classes="password-modal__spinner" show={true} />
                        </div>
                    }
                </Modal.Footer>
            </Modal>
        )
    }
}
const mapStateToProps = state => ({
});
export default connect(
    mapStateToProps,
    { showWarningMessage }
)(ConfirmModal);



// WEBPACK FOOTER //
// ./src/components/ConfirmModal/ConfirmModal.jsx